import { FC, ReactNode, useRef, useMemo } from "react";
import { useOnClickOutside } from "src/hooks/useOnClickOutside";
import { useDropdownWrapperRef } from "src/atoms/DropDown/Dropdown";

interface Props {
  handler: () => void;
  children: ReactNode;
}

const OutsideClickableBox: FC<Props> = ({ handler, children, ...rest }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const dropdownWrapperRef = useDropdownWrapperRef();

  const refsToCheck = useMemo(
    () => (dropdownWrapperRef ? [ref, dropdownWrapperRef] : ref),
    [dropdownWrapperRef]
  );

  useOnClickOutside(refsToCheck, handler);

  return (
    <div ref={ref} {...rest}>
      {children}
    </div>
  );
};

export { OutsideClickableBox };
